import {useEffect, useState} from "react";
import {getDataExplorerAnalysisAsync} from "../../../../redux/AsyncActions/data-explorer.async";
export const useGetSensorAnalysis = (sensorId, method = "get_raw_smooth") => {
  const [isLoading, setLoading] = useState(false);
  const [analysis, setAnalysis] = useState({});
  useEffect(() => {
    const payload = {
      sensor_id: sensorId,
      method,
    };
    const getAnalysis = async () => {
      try {
        setLoading(true);
        const response = await getDataExplorerAnalysisAsync({data: payload}, false);
        setLoading(false);
        setAnalysis(response?.data?.data || {});
      } catch (e) {
        setLoading(false);
      }
    };
    getAnalysis();
  }, [method, sensorId]);
  return {analysis, isLoading};
};
